module.exports = __webpack_public_path__ + "static/media/icon2.1cdbc311.svg";